import React from "react";
import {NavLink} from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import Config from "Config";
import axios from "axios";

class Footer extends React.Component {
  constructor() {
    super();
    this.state = {
      data: {}
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    axios
      .get(Config().endpoints.api + "/settings")
      .then(response => {
        if (response.data) {
          this.setState({
            data: response.data
          });
        }
      })
      .catch(error => {});
  }

  render() {
    return (
      <div>
        <div id="footer-sitemap" className="content-section no-spacing">
          <ul>
            <li>
              <ul>
                <li className="title">Kontakt</li>
                <div>{ReactHtmlParser(this.state.data.settings_address)}</div>
                <br />
                <li>
                  <span className="bold fixed-width-small">Tel</span>
                  <a href={"tel:" + this.state.data.settings_telefon}>
                    {this.state.data.settings_telefon}
                  </a>
                </li>
                <li>
                  <span className="bold fixed-width-small">E-Mail</span>
                  <a href={"mailto:" + this.state.data.settings_email}>
                    {this.state.data.settings_email}
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <ul>
                <li className="title">Sitemap</li>
                <li>
                  <NavLink to="/">Startseite</NavLink>
                </li>
                <li>
                  <NavLink to="/">Was wir können</NavLink>
                </li>
                <li>
                  <NavLink to="/">Kontakt</NavLink>
                </li>
              </ul>
            </li>
            <li>
              <ul>
                <li className="title">Rechtliches</li>
                <li>
                  <NavLink to="/datenschutz/">Datenschutz</NavLink>
                </li>
                <li>
                  <NavLink to="/impressum/">Impressum</NavLink>
                </li>
              </ul>
            </li>
            <li>
              <ul>
                <li className="title">Öffnungszeiten</li>
                <li>
                  <div>
                    {ReactHtmlParser(this.state.data.settings_opening_hours)}
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div id="footer-copy-container">
          <div className="content-section no-spacing">
            <div id="footer-copy-wrapper">
              <div id="footer-copy-company">© 2018 Dionysos-Events</div>
              <div id="footer-copy-privacy">
                <ul>
                  <li>
                    <NavLink to="/datenschutz/">Datenschutz</NavLink>
                  </li>
                  <li>
                    <NavLink to="/impressum/">Impressum</NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js